import React, { FC } from "react";
import { Card, Button, Col } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { IPlan } from "./constants";
import "../../App.css";

interface Props {
  plan: IPlan;
  onClick: (e: IPlan) => void;
}
const PlanCard: FC<Props> = ({ plan, onClick }) => {
  return (
    <Col xs={24} sm={12} md={8} style={{ display: 'flex' }}>
      <Card className="pricing-card" title={plan.title} style={{ width: '100%' }}>
        <div className="card-body-container">
          <div className="card-description">
            <p className="plan-price">
              {plan.preFix || ""}
              {plan.salePrice || plan.price}
              {plan.postFix && (
                <span style={{ fontSize: 15 }}>{plan.postFix}</span>
              )}
            </p>
            {plan.note && (
              <div style={{
                background: '#d1bd21',
                color: '#000',
                fontSize: 13,
                fontWeight: 600,
                borderRadius: 20,
                padding: '4px 14px',
                display: 'inline-block',
                marginBottom: 12,
              }}>
                {plan.note}
              </div>
            )}
            {/* {plan.salePrice && (
              <div className="sale-price-container">
                <p className="sale-price-badge">
                  <span className="actual-price">
                    Actual Price: {plan.preFix || ""}
                    {plan.price}
                  </span>
                  <span className="percentage">
                    (
                    {((plan.salePrice || 0) / parseInt(plan.price.toString())) *
                      100}{" "}
                    % OFF)
                  </span>
                </p>
              </div>
            )} */}
            <ul className="plan-features">
              {plan.features.map((feature, i) => (
                <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                  <CheckCircleFilled style={{ color: '#d1bd21', fontSize: 14, marginTop: 2, flexShrink: 0 }} />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>
          {plan.btn && (
            <Button
              type="primary"
              className="plan-button"
              onClick={() => onClick(plan)}
            >
              {plan.btn}
            </Button>
          )}
        </div>
      </Card>
    </Col>
  );
};

export default PlanCard;
